import authRootSaga from "./auth-root-saga";
import teamManagementRootSaga from "./team-management-root-saga";
import customerProfile from "./customer-profile";
import videosRootSaga from "./videos-root-saga";
import { all } from "redux-saga/effects";
import {
  getAllPublishedProgramsWatcher,
  getProgramsByMonthWatcher,
  setAvailDateWatcher,
  setBlockDateWatcher,
  getHolidaysByMonthWatcher,
  addHolidayWatcher,
  removeHolidayWatcher,
} from "../calendar-saga";

export default function* rootSaga() {
  yield all([
    authRootSaga(),
    teamManagementRootSaga(),
    customerProfile(),
    videosRootSaga(),
    getAllPublishedProgramsWatcher(),
    getProgramsByMonthWatcher(),
    setAvailDateWatcher(),
    setBlockDateWatcher(),
    getHolidaysByMonthWatcher(),
    addHolidayWatcher(),
    removeHolidayWatcher(),
  ]);
}

